import copy from 'copy-to-clipboard';

export default class CopyLink {
  constructor({ el }) {
    this.el = el;
    this.init();
  }

  init() {
    this.el.addEventListener('click', () => {
      const url = this.el.dataset.url && this.el.dataset.url !== '' ? this.el.dataset.url : window.location.href;
      let successText =
        this.el.dataset.successText && this.el.dataset.successText !== '' ? this.el.dataset.successText : 'Link Copied';

      if (url) {
        copy(url);

        // get current innerHTML
        const initialInnerHTML = this.el.innerHTML;

        this.el.innerHTML = successText;

        setTimeout(() => {
          this.el.innerHTML = initialInnerHTML;
        }, 1800);
      }
    });
  }
}
